import React from 'react'

import { Progress } from 'antd'

import type { LntProgressProps } from './types'

export const LntProgress: React.FC<LntProgressProps> = props => {
  return <Progress { ...props } />
}
